import * as RadixDialog from '@radix-ui/react-dialog';
import { SignIn } from './sign_in.component';
import styled, { keyframes } from 'styled-components';
import { restrictedZIndexes } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';

interface Props {
	__TEMP__onCloseSignIn: () => void;
}

const contentShow = keyframes`
	from {
		opacity: 0;
		transform: scale(0.96);
	}
  to {
		opacity: 1;
		transform: scale(1);
	}
`;

const StyledDialogContent = styled(RadixDialog.Content)`
	background-color: ${tokens.color.bg.page};
	display: flex;
	overflow: hidden;
	position: fixed;
	inset: 0;
	animation-duration: 250ms;
	animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
	/* Needs to use a high z-index to have it appear on top of other elements */
	z-index: ${restrictedZIndexes.DANGER};
	overflow-y: auto;

	&:focus {
		outline: none;
	}

	@media (prefers-reduced-motion: no-preference) {
		animation-name: ${contentShow};
	}
`;

export function SignInModal(props: Props): JSX.Element {
	return (
		<RadixDialog.Root
			defaultOpen
			onOpenChange={(value) => {
				if (!value) {
					props.__TEMP__onCloseSignIn();
				}
			}}
		>
			<StyledDialogContent>
				<SignIn {...props} />
			</StyledDialogContent>
		</RadixDialog.Root>
	);
}
